// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3C7U5","containerItemsCenter":"Skeleton_containerItemsCenter__3NkIG"};